// Generated by Argon compiler — do not edit by hand.
// CSR store output: reactive shared state with no runtime dependency.

const __argonSubs = new Map();

function __argonNotify(key) {
  for (const fn of __argonSubs.get(key) ?? []) fn();
}

export function argonSubscribe(key, fn) {
  let set = __argonSubs.get(key);
  if (!set) __argonSubs.set(key, set = new Set());
  set.add(fn);
  return () => {
    set.delete(fn);
    if (set.size === 0) __argonSubs.delete(key);
  };
}

export const threadStream = {};
let __argon_threadStream_threadId = "";
Object.defineProperty(threadStream, "threadId", {
  enumerable: true,
  get() { return __argon_threadStream_threadId; },
  set(value) {
    if (Object.is(__argon_threadStream_threadId, value)) return;
    __argon_threadStream_threadId = value;
    __argonNotify("threadStream.threadId");
  },
});

let __argon_threadStream_running = false;
Object.defineProperty(threadStream, "running", {
  enumerable: true,
  get() { return __argon_threadStream_running; },
  set(value) {
    if (Object.is(__argon_threadStream_running, value)) return;
    __argon_threadStream_running = value;
    __argonNotify("threadStream.running");
  },
});

let __argon_threadStream_messages = [];
Object.defineProperty(threadStream, "messages", {
  enumerable: true,
  get() { return __argon_threadStream_messages; },
  set(value) {
    if (Object.is(__argon_threadStream_messages, value)) return;
    __argon_threadStream_messages = value;
    __argonNotify("threadStream.messages");
  },
});

let __argon_threadStream_toolCalls = [];
Object.defineProperty(threadStream, "toolCalls", {
  enumerable: true,
  get() { return __argon_threadStream_toolCalls; },
  set(value) {
    if (Object.is(__argon_threadStream_toolCalls, value)) return;
    __argon_threadStream_toolCalls = value;
    __argonNotify("threadStream.toolCalls");
  },
});

let __argon_threadStream_subagents = [];
Object.defineProperty(threadStream, "subagents", {
  enumerable: true,
  get() { return __argon_threadStream_subagents; },
  set(value) {
    if (Object.is(__argon_threadStream_subagents, value)) return;
    __argon_threadStream_subagents = value;
    __argonNotify("threadStream.subagents");
  },
});

let __argon_threadStream_agentTranscripts = [];
Object.defineProperty(threadStream, "agentTranscripts", {
  enumerable: true,
  get() { return __argon_threadStream_agentTranscripts; },
  set(value) {
    if (Object.is(__argon_threadStream_agentTranscripts, value)) return;
    __argon_threadStream_agentTranscripts = value;
    __argonNotify("threadStream.agentTranscripts");
  },
});

let __argon_threadStream_pendingApprovals = [];
Object.defineProperty(threadStream, "pendingApprovals", {
  enumerable: true,
  get() { return __argon_threadStream_pendingApprovals; },
  set(value) {
    if (Object.is(__argon_threadStream_pendingApprovals, value)) return;
    __argon_threadStream_pendingApprovals = value;
    __argonNotify("threadStream.pendingApprovals");
  },
});

let __argon_threadStream_pendingQuizzes = [];
Object.defineProperty(threadStream, "pendingQuizzes", {
  enumerable: true,
  get() { return __argon_threadStream_pendingQuizzes; },
  set(value) {
    if (Object.is(__argon_threadStream_pendingQuizzes, value)) return;
    __argon_threadStream_pendingQuizzes = value;
    __argonNotify("threadStream.pendingQuizzes");
  },
});

export function argonSnapshot() {
  return {
    threadStream: { threadId: threadStream.threadId, running: threadStream.running, messages: threadStream.messages, toolCalls: threadStream.toolCalls, subagents: threadStream.subagents, agentTranscripts: threadStream.agentTranscripts, pendingApprovals: threadStream.pendingApprovals, pendingQuizzes: threadStream.pendingQuizzes },
  };
}

export function argonHydrate(snapshot) {
  if (!snapshot) return;
  if (snapshot.threadStream) {
    if ("threadId" in snapshot.threadStream) threadStream.threadId = snapshot.threadStream.threadId;
    if ("running" in snapshot.threadStream) threadStream.running = snapshot.threadStream.running;
    if ("messages" in snapshot.threadStream) threadStream.messages = snapshot.threadStream.messages;
    if ("toolCalls" in snapshot.threadStream) threadStream.toolCalls = snapshot.threadStream.toolCalls;
    if ("subagents" in snapshot.threadStream) threadStream.subagents = snapshot.threadStream.subagents;
    if ("agentTranscripts" in snapshot.threadStream) threadStream.agentTranscripts = snapshot.threadStream.agentTranscripts;
    if ("pendingApprovals" in snapshot.threadStream) threadStream.pendingApprovals = snapshot.threadStream.pendingApprovals;
    if ("pendingQuizzes" in snapshot.threadStream) threadStream.pendingQuizzes = snapshot.threadStream.pendingQuizzes;
  }
}

const __argonPayload = globalThis.document?.querySelector?.('script[type="application/json"][data-argon-stores]');
if (__argonPayload?.textContent) argonHydrate(JSON.parse(__argonPayload.textContent));
